import clsx from 'clsx';
export function AgentDot({ active, className, label }: { active?: boolean; className?: string; label?: string }) {
  return (
    <span className={clsx('inline-flex items-center gap-1', className)} title={label || 'Agent'}>
      <span className={clsx('inline-block h-1.5 w-1.5 rounded-full bg-accent', active && 'pulse-dot')} />
      {label && <span className="text-xs text-muted">{label}</span>}
    </span>
  );
}
